import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getInspectionFiles: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/files`,
        params: {
            '$count': true
        }
    },
    getInspectionFile: {
        method: 'GET',
        url: `${BASE_PATH_API}/inspections/files/:fileId`
    },
    deleteInspectionFile: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/inspections/files/:fileId`
    },
    updateInspectionFile: {
        method: 'PUT',
        url: `${BASE_PATH_API}/inspections/files/:fileId`
    }
};

export function PropertyInspectionApi() {
    return createActions(actions);
}
